import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M9.5 6.5C9.5 7.3284 8.8284 8 8 8s-1.5-.6716-1.5-1.5S7.1716 5 8 5s1.5.6716 1.5 1.5m2 0C11.5 8.433 9.933 10 8 10S4.5 8.433 4.5 6.5 6.067 3 8 3s3.5 1.567 3.5 3.5M4 19v-5.3265C4.8655 13.3578 6.1783 13 7.3636 13c1.1933 0 2.984.3549 3.9064.6487V19c0 .5523.4477 1 1 1s1-.4477 1-1v-5.5601c0-.5578-.2694-1.2818-1.034-1.5725C11.2173 11.4802 8.9345 11 7.3636 11c-1.552 0-3.1532.4618-4.1183.8201C2.4515 12.1149 2 12.8717 2 13.6417V19c0 .5523.4477 1 1 1s1-.4477 1-1",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.4998 6.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6715-1.5 1.5-1.5 1.5.6716 1.5 1.5m2 0c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5M13.2725 19v-5.3265c.8654-.3157 2.1783-.6735 3.3636-.6735 1.1528 0 2.5915.3352 3.3636.6173V19c0 .5523.4477 1 1 1s1-.4477 1-1v-5.5601c0-.5509-.2573-1.2582-.9874-1.5722C20.097 11.4741 18.2039 11 16.6361 11c-1.5521 0-3.1532.4618-4.1183.8201-.7939.2948-1.2453 1.0516-1.2453 1.8216V19c0 .5523.4477 1 1 1s1-.4477 1-1",
        clipRule: "evenodd"
    }, "1")
], "AudienceMatched", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
